import {
  Person as PersonIcon,
  AddCircle as CreateIcon,
  ExitToApp as LogoutIcon,
  Home as HomeIcon,
  Print as PrintIcon,
  Shuffle as ShuffleIcon,
} from "@mui/icons-material";

const icons = {
  person: PersonIcon,
  create: CreateIcon,
  logout: LogoutIcon,
  home: HomeIcon,
  print: PrintIcon,
  shuffle: ShuffleIcon,
};

export default icons;
